export default "__VITE_ASSET__BQIBBuha__"